import Loader from "react-loader-spinner";
import { getAllBankAccount, getPayInCashTargetList, getAccountReport } from "../store/api/DocumentsAPI";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import { Fragment, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import { exportToExcel, invoiceTypesArray, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import DatePicker from "react-datepicker2";
import { useDispatch, useSelector } from "react-redux";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, PrinterFill, Search, List, ExclamationTriangle, Book, Link45deg } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { faNewspaper, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BihamtaMultiSelect from "../../Components/BihamtaMultiSelect";
import ModalAddEditChequeFunctions from "../Components/ModalAddEditChequeFunctions";
import moment from "moment-jalali";
const ViewAccountsReport = () => {
    const total = useRef({});
    const history = useHistory();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);
    const { reportTypeParam, cat, id } = useParams();
    const [reportType, setReportType] = useState("");
    const [searchData, setSearchData] = useState({});
    const [showFilter, setShowFilter] = useState(true);
    const [bankAccounts, setBankAccounts] = useState(null);
    const [cashTargets, setCashTargetList] = useState(null);
    const [modalCustomers, setModalCustomers] = useState({ show: false });
    const [modalCheqFunctions, setModalCheqFunctions] = useState({ Show: false });
    const { list, filterData } = useSelector(state => { return { list: state.DocumentReducer.accountsReport, filterData: state.DocumentReducer.accountReportFilters } });

    if (Array.isArray(list?.Data ?? "")) {
        total.current.Debit = list.Data.map(l => l.Debit).reduce((a, b) => a + b, 0);
        total.current.Credit = list.Data.map(l => l.Credit).reduce((a, b) => a + b, 0);
        total.current.RemainedDebit = total.current.Debit - total.current.Credit;
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function showModalCustomer(e) {
        if (e.key && !keyIsLetterOrNumber(e.keyCode, e.key)) {
            return;
        }
        const onSelect = (cust) => {
            setSearchData({
                ...searchData,
                AccountID: cust?.ID,
                AccountCat: cust?.Cat,
                AccountName: cust?.Name,
                AccountCode: cust?.Code
            })
        }
        setModalCustomers({
            show: true,
            invoiceCustomers: true,
            defaultAccType :"",
            setCustomerData: onSelect
        })
    }
    function toExcel() {
        if ((searchData.AccountID ?? "") === "") {
            if (reportType === "Customers") {
                setError("طرف حساب انتخاب نشده است");
            }
            else if (reportType === "Banks") {
                setError("حساب بانکی انتخاب نشده است");
            }
            else if (reportType === "CashTarget") {
                setError("حساب صندوف انتخاب نشده است");
            }
            return;
        }
        const url = `api/DocumentsAPI/GetAccountReport`;
        const searchArgs = { ...searchData };
        if (cat && id) {
            searchArgs.AccountCat = cat;
            searchArgs.AccountID = id;
        }
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("AccountReports", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function search() {
        setError(null);
        if (cat && id) {
            searchData.AccountCat = cat;
            searchData.AccountID = id;
        }
        if ((searchData.AccountID ?? "") === "") {
            if (reportType === "Customers") {
                setError("طرف حساب انتخاب نشده است");
            }
            else if (reportType === "Banks") {
                setError("حساب بانکی انتخاب نشده است");
            }
            else if (reportType === "CashTarget") {
                setError("حساب صندوف انتخاب نشده است");
            }
            return;
        }
        total.current = {};
        const pDateFrom = document.getElementsByName("DocumentDateFrom")[0].value;
        if (pDateFrom === "") {
            searchData.DocumentDateFrom = null;
        }
        const pDateTo = document.getElementsByName("DocumentDateTo")[0].value;
        if (pDateTo === "") {
            searchData.DocumentDateTo = null;
        }

        dispatch(getAccountReport(searchData));
    }
    function printReport(e) {
        if ((searchData.AccountID ?? "") === "") {
            if (reportType === "Customers") {
                setError("طرف حساب انتخاب نشده است");
            }
            else if (reportType === "Banks") {
                setError("حساب بانکی انتخاب نشده است");
            }
            else if (reportType === "CashTarget") {
                setError("حساب صندوف انتخاب نشده است");
            }
            return;
        }
        const searchArgs = { ...searchData };
        if (cat && id) {
            searchArgs.AccountCat = cat;
            searchArgs.AccountID = id;
        }
        searchArgs.Take = 0;
        searchArgs.Skip = 0;
        history.push({
            pathname: `/PrintViewer/AccountReports/${e.ctrlKey}`,
            state: {
                dataUrl: `api/DocumentsAPI/GetAccountReport`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function onAttachmentTypesChanged(item) {
        if (!searchData.AttachmentTypes) {
            searchData.AttachmentTypes = [];
        }
        const splited = item.value.split(",");
        if (item.checked) {
            if (!searchData.AttachmentTypes.includes(splited)) {

                if (item.value.contains("Formal")) {
                    searchData.FilterAttachmentTypes = [...searchData.AttachmentTypes, item.value];
                }
                searchData.AttachmentTypes.push(...splited);
                if (!item.value.contains("Formal")) {
                    searchData.FilterAttachmentTypes = [...searchData.AttachmentTypes];
                }
            }
        }
        else {
            searchData.AttachmentTypes = searchData.AttachmentTypes.filter(a => !splited.includes(a));
            let invoices = searchData.AttachmentTypes.filter(a => a.contains("Formal"));
            if (invoices?.length > 3) {
                invoices = invoices.join(',');
                searchData.FilterAttachmentTypes = [...searchData.FilterAttachmentTypes.filter(a => !a.contains("Formal")), invoices];
            }
        }
    }
    function gotoDocument(row) {
        if (row.e.ctrlKey) {
            window.open(`/Accounting/AddEditDocument/${row.DocumentID}`);
        }
        else {
            history.push(`/Accounting/AddEditDocument/${row.DocumentID}`);
        }
    }
    function showDocAttach(row) {
        const attachType = row.AttachmentType?.replaceAll("Formal", "") ?? "";
        if ((attachType === "")) {
            return;
        }
        if (invoiceTypesArray.some(i => i.TypeName.toLocaleLowerCase() === attachType.toLocaleLowerCase())) {
            window.open(`/Sale/Invoice/${attachType}/${row.AttachmentID}/${row.AttachmentIsFormalInvoice?.toString() === "true"}`);
        }
        else if (attachType.toLocaleLowerCase() === "install" || attachType.toLocaleLowerCase() === "repair") {
            window.open(`/Services/Service/${row.AttachmentID}/${row.AttachmentType}`)
        }
        else if (attachType?.toLowerCase().contains("cheque") || attachType?.toLowerCase().contains("in_") || attachType?.toLowerCase().contains("out_")) {
            setModalCheqFunctions({
                Show: true,
                FunctionID: row.AttachmentID,
                ChequeStatus: row.AttachmentType/*,
                    ChequeID: row.ChequeID*/
            })
        }

    }
    const selectOptions = [
        { Value: "install", Text: "نصب" },
        { Value: "repair", Text: "تعمیر" },
        {
            Value: "FormalSale,FormalPurchase,FormalReturnFromSale,FormalReturnFromPurchase," +
                "FormalTransfer,FormalBorrow,FormalReturnFromBorrow,FormalOldParts,FormalServiceInvoice" +
                "FormalSale_2Discount,in_1_RecieveCheque,in_2_PutInAccount,in_3_GiveToCustomer,in_4_Cash,in_6_ReturnAndCustomerPay," +
                "in_8_CustomerReturns,out_1_PayCheque,out_2_PassCheque,out_3_CustomerReturns", Text: "فروش و انبار"
        }
    ]
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "تاریخ سند", colName: "PDocumentDate", showInMobile: true },
        { colTitle: "شماره سند", colName: "DocumentNumber", showInMobile: true },
        { colTitle: "شرح", colName: "RowDescription" },
        { colTitle: "بدهکار", colName: "Debit", colType: "currency" },
        { colTitle: "بستانکار", colName: "Credit", colType: "currency" },
        { colTitle: "مانده", colName: "RemainedDebit", colType: "currency" },
        { colTitle: "ماهیت مانده", colName: "PRowAccountType" }
    ]
    const tableButtons = [
        {
            type: "common", title: "سند حسابداری", tooltip: "سند حسابداری(برای باز شدن در تب جدید دکمه کنترل را نگه دارید)",
            icon: <Book size={18} className="rowBtn" color="#0b2e89" />, onclick: gotoDocument, className: "group-Btn-smalll", showCondition: (r) => Number(r.DocumentID) > 0
        },
        { type: "common", title: "فرم مرتبط", tooltip: "فرم مرتبط(برای باز شدن در تب جدید دکمه کنترل را نگه دارید)", 
            icon: <Link45deg size={19} className="rowBtn" color="#ff5500" />, onclick: showDocAttach, className: "group-Btn-smalll", showCondition: (r) => Number(r.AttachmentID) > 0 }
    ]
    useEffect(() => {
        if (list?.Data) {
            list.Data = [];
        }
        total.current = {};
        document.body.classList = "notMain";
        document.title = "بی همتا-امور مالی";
        setSearchData({});
        if (reportTypeParam === "CashTarget") {
            getPayInCashTargetList(setCashTargetList);
        }
        else if (reportTypeParam === "Banks") {
            getAllBankAccount("", setBankAccounts);
        }
        setReportType(reportTypeParam);
        if (cat && id) {
            search();
        }
    }, [reportTypeParam])
    useEffect(() => {
        if (filterData) {
            if ((!cat || Number(cat) === Number(filterData.AccountCat)) && (!id || Number(id) === Number(filterData.AccountID))) {
                setSearchData(filterData);
                Object.assign(searchData, filterData);
                search();
            }
        }
    }, [])
    return (
        <div className="container-fluid mt-3">
            <br />
            <ModalAddEditChequeFunctions popData={modalCheqFunctions} setPopData={setModalCheqFunctions} />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faNewspaper} size="lg" />&nbsp;
                    مشاهده حساب ها
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    {
                        reportType === "Customers" &&
                        <ModalSelectCustomer popData={modalCustomers} setCustomerPopup={setModalCustomers} />
                    }
                    <Row id="divFilters" className="rowBorder" >
                        <div className="rowTitle">
                            فیلترهای جستجو&nbsp;
                            {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                            {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                        </div>
                        {
                            reportType === "Customers" && !cat &&
                            <Col md={2} className="form-group">
                                <label>طرف حساب: </label>
                                <Form.Control onKeyDown={showModalCustomer} readOnly value={searchData?.AccountName ?? ""} />
                                <Button className="btn-input-tiny" onClick={showModalCustomer} style={{ top: 27 }}><List size={22} /></Button>
                            </Col>
                        }
                        {
                            reportType === "CashTarget" &&
                            <Col md={2} className="form-group">
                                <label>حساب صندوق: </label>
                                <select className="form-control" defaultValue={searchData?.AccountID ?? ""} onChange={e => { searchData.AccountCat = 1; searchData.AccountID = e.target.value }}>
                                    <option value="">انتخاب کنید</option>
                                    {Array.isArray(cashTargets?.Data ?? "") &&
                                        cashTargets.Data.map((item, i) => <option value={item.AccountID} key={i}>{item.AccountName}</option>)
                                    }
                                </select>
                            </Col>
                        }
                        {
                            reportType === "Banks" &&
                            <Col md={2} className="form-group">
                                <label>حساب بانک: </label>
                                <select className="form-control" defaultValue={searchData?.AccountID ?? ""} onChange={e => { searchData.AccountCat = 2; searchData.AccountID = e.target.value }}>
                                    <option value="">انتخاب کنید</option>
                                    {Array.isArray(bankAccounts?.Data ?? "") &&
                                        bankAccounts.Data.map((item, i) => <option value={item.ID} key={i}>{item.BankMixedName}</option>)
                                    }
                                </select>
                            </Col>
                        }
                        <Col md={1} className="form-group">
                            <label>از تاریخ: </label>
                            <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DocumentDateFrom" value={searchData?.DocumentDateFrom ? moment(searchData.DocumentDateFrom) : null}
                                onChange={val => setSearchData({ ...searchData, DocumentDateFrom: val.local("en").format("YYYY-MM-DD") })} />
                        </Col>
                        <Col md={1} className="form-group">
                            <label>تا تاریخ: </label>
                            <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DocumentDateTo" value={searchData?.DocumentDateTo ? moment(searchData.DocumentDateTo) : null}
                                onChange={val => setSearchData({ ...searchData, DocumentDateTo: val.local("en").format("YYYY-MM-DD") })} />
                        </Col>
                        <Col md={2} className="form-group">
                            <label>ترتیب نمایش: </label>
                            <select className="form-control" onChange={e => setSearchData({ ...searchData, OrderBy: e.target.value })} value={searchData?.OrderBy ?? ""}>
                                <option value="">به ترتیب ثبت سند</option>
                                <option value="DocNumber">شماره سند-صعودی</option>
                                <option value="DocNumber DESC">شماره سند-نزولی</option>
                                <option value="DocDate">تاریخ سند-صعودی</option>
                                <option value="DocDate DESC">تاریخ سند-نزولی</option>
                            </select>
                        </Col>
                        {reportType === "Customers" &&
                            <Col md={2} className="form-group">
                                <label>نوع سند:</label>
                                <BihamtaMultiSelect dataSource={selectOptions} valueItem="Value" displayItem="Text" onItemCheckChanged={onAttachmentTypesChanged} defaultCheckedList={searchData?.FilterAttachmentTypes} />
                            </Col>
                        }
                        <Col md={4} style={{ display: showFilter ? "flex" : "none", alignItems: "flex-end" }}>
                            <div className="rowBorder" style={{ padding: "9px 5px 9px 5px", fontSize: "12px", color: "blue" }}>
                                <input type="checkbox" className="form-check-input mt-0" onChange={e => setSearchData({...searchData,IsGrouped: e.target.checked})} checked={searchData?.IsGrouped ?? false}/>&nbsp;نمایش تجمیعی اسناد&nbsp;&nbsp;
                                <input type="checkbox" className="form-check-input mt-0" onChange={e => setSearchData({...searchData,ConvertSaleToService : e.target.checked})} checked={searchData?.ConvertSaleToService??false}/>&nbsp;تبدیل اسناد فاکتور سرویس&nbsp;&nbsp;
                                {reportType === "Customers" &&
                                    <Fragment>
                                        <input type="checkbox" className="form-check-input mt-0" onChange={e => setSearchData({...searchData,ShowFromAfterDurationalSettlement : e.target.checked})} checked={searchData?.ShowFromAfterDurationalSettlement??false}/>&nbsp;نمایش از آخرین تسویه
                                    </Fragment>
                                }
                            </div>
                        </Col>
                    </Row>
                    {error && <Alert variant="danger" className="mt-1"><ExclamationTriangle size={18} />&nbsp; {error} <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setError(null)} /></Alert>}
                    <Button className="group-Btn-large mt-1" onClick={search}><Search size={18} />&nbsp;نمایش جزئیات حساب </Button>
                    {!pending &&
                        <div style={{ padding: 1, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} rowButtons={tableButtons} objectName="accountsReport" reducerName="DocumentReducer" style={{ whiteSpace: "nowrap" }} searchable maxHeight={500} />
                    <table>
                        <thead>
                            <tr>
                                <th>بدهکار</th>
                                <th>بستانکار</th>
                                <th>مانده</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <input className="tableRowInput" style={{ color: "red" }} value={total.current.Debit?.toLocaleString(navigator.languages) ?? ""} readOnly />
                                </td>
                                <td>
                                    <input className="tableRowInput" style={{ color: "blue" }} value={total.current.Credit?.toLocaleString(navigator.languages) ?? ""} readOnly />
                                </td>
                                <td>
                                    <input className="tableRowInput" style={{ color: total.current.RemainedDebit > 0 ? "red" : "blue", direction: "ltr", textAlign: "right" }} value={total.current.RemainedDebit?.toLocaleString(navigator.languages) ?? ""} readOnly />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Card.Body>
            </Card>
        </div>
    )
}
export default ViewAccountsReport;